<script lang="ts">
    import lowPolyBell from '../../../assets/low-poly-bell.png';
    import KpHeading from 'shared/components/kp-heading/KpHeading.svelte';
</script>

<div class="sutor-homepage-notifications-part">
    <img class="low-poly-bell" src={lowPolyBell} alt="low-poly-bell"/>
    <div class="texts-container">
        <KpHeading type="h2">Vše máte vyřízeno</KpHeading>
        <span>Nemáte žádné nové oznámení, ani nic dalšího, co by vyžadovalo vaši pozornost.</span>
    </div>
</div>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    .sutor-homepage-notifications-part {
        align-self: center;
        align-items: center;
        display: flex;
        padding: @spacing-m 0;
        gap: @spacing-ml;

        .low-poly-bell {
            height: 84px;
        }

        .texts-container {
            display: flex;
            flex-direction: column;
            gap: @spacing-xs;

            span {
                font-size: @font-size-sm;
                color: @themed-text-muted;
            }
        }
    }
</style>